module.exports = __webpack_public_path__ + "img/21_34.97d5d151.png";